import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Label } from 'semantic-ui-react';

import { fetchM } from '../../actions/fetchM';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { DEFAULT_STATUS, listPath } from '../../utils/crmOps';

const ns = { ns: TRANSLATION_FILES.translation };

// How many outbox rows need a person (MS-6630): one read of the ops list's first page, one row
// wide, for the count header. Renders nothing until it knows, and nothing when the answer is zero
// or cannot be read — a badge that says "0" or "?" is noise next to a module name.
export class CrmNeedsHumanBadge extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  }

  state = { count: null };

  componentDidMount() {
    this.mounted = true;
    this.read();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  read = async () => {
    let res;
    try {
      const path = listPath({ status: DEFAULT_STATUS, page: 1, limit: 1 });
      res = await this.props.dispatch(fetchM(path, {
        credentials: 'include', returnForbidden: true, ignoreNotFound: true,
      }));
    } catch (err) {
      res = null;
    }
    if (!this.mounted || !res || !res.ok) return;
    let count = NaN;
    try {
      count = parseInt(res.headers.get('m-data-count'), 10);
    } catch (e) {
      count = NaN;
    }
    if (Number.isFinite(count) && count > 0) this.setState({ count });
  }

  render() {
    const { count } = this.state;
    if (!count) return null;
    return (
      <Label
        circular
        color="orange"
        size="small"
        data-testid="crm-needs-human-badge"
        title={this.props.t('CRM sync rows needing attention', ns)}
      >
        {count}
      </Label>
    );
  }
}

export default withTranslation(namespaces)(connect()(CrmNeedsHumanBadge));



// WEBPACK FOOTER //
// ./src/components/Crm/CrmNeedsHumanBadge.jsx